import { Sdk } from '@/network/graphql.g'
import { useMhub } from '@/providers/mhubProvider'
import { MHubCustomer } from '@/providers/mhub/userManager'
import { useUser } from '@/providers/userProvider'
import useGraphQl from 'hooks/useGraphQl'

export const useMhubIdentifyByEmail = (): ((
  customer: MHubCustomer
) => Promise<void>) => {
  const { request } = useGraphQl()
  const { pushRSTSFromEmail } = useMhub()
  const { isLoggedIn } = useUser()

  return async (customer: MHubCustomer) => {
    const email = customer?.email?.trim()
    if (!email || isLoggedIn) {
      return
    }

    const { response, success } = await request(
      (sdk: Sdk) => ({
        method: sdk.getRSTSFromEmail,
        variables: { email }
      }),
      true
    )
    const found = success ? response?.getRSTSFromEmail : null

    pushRSTSFromEmail({
      email,
      rs: customer.rs ?? found?.rs,
      ts: customer.ts ?? found?.ts,
      telephone: customer.telephone ?? found?.telephone,
      fbLogin: customer.fbLogin ?? found?.fbLogin
    })
  }
}
